gsap.registerPlugin(ScrollTrigger); //For scroll triggers
const tlHero = gsap.timeline({defaults: {duration: 1, ease: "power4.in"}});
tlHero
    .fromTo("header", {pointerEvents: "none", opacity: 0}, {pointerEvents: "auto", opacity: 1})
    .fromTo(".hero__title", {pointerEvents: "none", opacity: 0, y: -10}, {pointerEvents: "auto", opacity: 1, y: 0, ease: "ease"})
    .fromTo(".hero__desc", {pointerEvents: "none", opacity: 0, y: -10,}, {pointerEvents: "auto", opacity: 1, y: 0, ease: "ease"}, "<.5")
    .fromTo(".hero__img__girl", {pointerEvents: "none", opacity: 0}, {pointerEvents: "none", opacity: 1, ease: "ease"}, "<.5")
    .fromTo(".hero__img .blob", {pointerEvents: "none", opacity: 0}, {pointerEvents: "none", opacity: 0.35, ease: "ease"}, "<0")
    .fromTo(".hero__links", {pointerEvents: "none", opacity: 0, y: -10}, {pointerEvents: "auto", opacity: 1, y: 0, ease: "ease"}, "<1.2")
;



gsap.to(".hero-container .wave", {
    duration: 8,
    ease: "ease",
    x: "-10%",
    repeat: -1,
    yoyo: true
});

gsap.to(".footer-wave", {
    duration: 8,
    ease: "ease",
    x: "10%",
    repeat: -1,
    yoyo: true
});

//For animating hero img

/*hero img icons*/

gsap.fromTo("#file-pdf-solid", {
    y: -50,
    scale: 0.5
    }, {
    duration: 4.5,
    opacity: 0,
    y: 250,
    scale: .8,
    ease: "Back.easeOut.config(1.7)",
    repeat: -1,
    repeatDelay: 1
});

gsap.fromTo("#music", {
    y: -80,
    scale: 0.5
    }, {
    duration: 4,
    opacity: 0,
    y: 250,
    scale: 1.03,
    ease: "Back.easeOut.config(1.7)",
    repeat: -1,
    repeatDelay: 1.2
});

gsap.fromTo("#clapperboard-solid", {
    y: -160,
    scale: 0.5
    }, {
    duration: 4.5,
    opacity: 0,
    y: 250,
    scale: 1.03,
    ease: "Back.easeOut.config(1.7)",
    repeat: -1,
    repeatDelay: 1
});

gsap.fromTo("#file-lines-solid", {
    y: -200,
    scale: 0.5
    }, {
    duration: 4.8,
    opacity: 0,
    y: 250,
    scale: 1.03,
    ease: "Back.easeOut.config(1.7)",
    repeat: -1,
    repeatDelay: 1
});

gsap.fromTo("#images-solid", {
    y: -230,
    scale: 0.5
    }, {
    duration: 4,
    opacity: 0,
    y: 200,
    scale: 1.03,
    ease: "Back.easeOut.config(1.7)",
    repeat: -1,
    repeatDelay: 1
});

gsap.fromTo("#file-code-solid", {
    y: -200,
    scale: 0.5
    }, {
    duration: 4.5,
    opacity: 0,
    y: 100,
    scale: 1.03,
    ease: "Back.easeOut.config(1.7)",
    repeat: -1,
    repeatDelay: 1
});

/*LEFT HAND*/

gsap.to("#left-hand", {
    y: 3,
    duration: .8,
    repeat: -1,
    yoyo: true
});

/*RIGHT HAND*/

gsap.fromTo("#Vector_23", {
    y: -3  
}, {
    y: 3,
    duration: .9,
    repeat: -1,
    yoyo: true
});

gsap.fromTo("#Vector_24", {
    y: -3
}, {
    y: 3,
    duration: .9,
    repeat: -1,
    yoyo: true
});

gsap.fromTo("#Vector_25", {
    y: -3  
}, {
    y: 3,
    duration: .9,
    repeat: -1,
    yoyo: true
});

gsap.fromTo("#Vector_26", {
    y: -3  
}, {
    y: 3,
    duration: .9,
    repeat: -1,
    yoyo: true
});

gsap.fromTo("#Vector_27", {
    y: -3  
}, {
    y: 3,
    duration: .9,
    repeat: -1,
    yoyo: true
});

gsap.fromTo("#Vector_28", {
    y: -3  
}, {
    y: 3,
    duration: .9,
    repeat: -1,
    yoyo: true
});

gsap.fromTo("#Vector_29", {
    y: -3  
}, {
    y: 3,
    duration: .9,
    repeat: -1,
    yoyo: true
});

gsap.fromTo("#Vector_30", {
    y: -3  
}, {
    y: 3,
    duration: .9,
    repeat: -1,
    yoyo: true
});


/*HEAD*/

gsap.to("#HAIR", {
    y: 3,
    x: -8,
    duration: 2,
    repeat: -1,
    yoyo: true,
    rotate: "-3deg"
});

gsap.to("#HAIR_2", {
    y: 3,
    x: -8,
    duration: 2,
    repeat: -1,
    yoyo: true,
    rotate: "-3deg"
});

gsap.to("#HEAD_2", {
    y: 3,
    x: -8,
    duration: 2,
    repeat: -1,
    yoyo: true,
    rotate: "-5deg"
});

gsap.to("#EARRING", {
    y: 3,
    x: -10,
    duration: 2,
    repeat: -1,
    yoyo: true,
});

/*SCARF*/
gsap.to("#Vector_36", {
    x: -4,
    y: 3,
    duration: 1.8,
    repeat: -1,
    yoyo: true
});

gsap.to("#Vector_37", {
    x: -4,
    y: 1,
    duration: 1.8,
    repeat: -1,
    yoyo: true
});

gsap.to("#Vector_38", {
    x: 0,
    y: 2,
    duration: 1.8,
    repeat: -1,
    yoyo: true
});


//For scroll trigger animations

gsap.from(".transition2", {
    scrollTrigger: {
        trigger: ".transition2",
        start: "top 60%",
        markers: false,
        toggleActions: "restart none none reverse"
    },
    y: -50,
    opacity: 0,
    stagger: .5,
    ease: "ease",
    delay: .4
});

gsap.from(".features .featured__title", {
    scrollTrigger: {
        trigger: ".features .featured__title",
        start: "top 70%",
        markers: false,
        toggleActions: "restart none none reverse"
    },
    y: -50,
    opacity: 0,
    duration: 1,
    delay: .4
});

gsap.from(".card", {
    scrollTrigger: {
        trigger: ".card",
        start: "top 65%",
        scrub: 5,
        markers: false,
        toggleActions: "restart none none reverse"
    },
    y: -50,
    opacity: 0,
//        scale: .5,
    stagger: .5,
    ease: "back.easeOut.config(1.7)",
    duration: 1,
    delay: .4
});

gsap.from(".call-to-action", {
    scrollTrigger: {
        trigger: ".call-to-action",
        toggleActions: "restart none none pause"
    },
    y: -50,
    opacity: 0,
    //    scale: 0.1,
    ease: "back.easeOut.config(1.7)",
    duration: 1,
    delay: 1
});





//.fromTo(".hero__img .blob", {opacity: 0, scale: 0.1}, {opacity: 1, scale: 1.2, ease: "Back.easeOut.config(1.7)", duration: 1}, "<.3")
